import { Component, ViewChild } from "@angular/core";
import { galleryTransition, fadeInOutAnimation } from "../../animations";
import { Catalog } from "../../data/catalog";
import { CatalogService } from "../../services/catalog.service";
import { Router } from "@angular/router";
import { OnInit } from "@angular/core";
import { WindowService } from "../../services/window.service";
import { SupermodalComponent } from "@app/components/common/supermodal.component";
import { UserService } from "@app/services/user.service";

@Component({
  templateUrl: "./home.component.html",
  animations: [galleryTransition, fadeInOutAnimation],
})
export class HomeComponent {
  hasAccessToTearSheet: boolean = false;

  constructor(private userService: UserService) {
    this.userService.hasAccess("tear-sheet").then((hasAccess) => {
      this.hasAccessToTearSheet = hasAccess;
    });
  }
}
